import React from 'react'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import PortableText from '../../portableText'
import { HeroContentContainer, Centered, Wrapper, HeroCopy } from '../../Hero/Hero.styles'
import VSMWave from './VSMWave'
import { MidSection, TabSection, TabSectionTab, TabSectionTopBar, VSMHeroContainer } from './VSMHero.styles'
import VSMHeroImg from './VSMHeroImg'

export default function VSMHero({
	label,
	heading,
	heroCopy,
	heroImage,
	vsmHeroImageModal,
	midSectionCopy,
	tabLabel,
	tabSectionCopy,
}) {
	const VSMHeroCopy = ({ portableTextBlock }) => <PortableText blocks={portableTextBlock} />
	const colorlist = { light: '#80bc00', title: 'solidGreen', value: '#80bc00' }

	return (
		<VSMHeroContainer>
			<Wrapper colorlist={colorlist}>
				<HeroContentContainer>
					<Centered className="green">
						<h3 className="hero-label">{label}</h3>
						<h1 className="hero-title">{heading}</h1>
						<HeroCopy>
							<VSMHeroCopy {...heroCopy} />
						</HeroCopy>
					</Centered>
					{/* <SanityImage
						{...heroImage}
						asset={heroImage.asset}
						width={96}
						alt={heroImage.alt}
						className="heroImage"
					/> */}
					<VSMHeroImg {...vsmHeroImageModal} />
					<HeroCopy className="midsection">
						<VSMHeroCopy {...midSectionCopy} />
					</HeroCopy>
				</HeroContentContainer>
			</Wrapper>
			<VSMWave colorlist={colorlist} />
			<MidSection />
			<TabSectionTopBar>
				<TabSectionTab />
				<p className="tab-label">{tabLabel}</p>
			</TabSectionTopBar>
			<TabSection>
				<VSMHeroCopy {...tabSectionCopy} />
			</TabSection>
		</VSMHeroContainer>
	)
}

VSMHero.propTypes = {
	label: PropTypes.string,
	tabLabel: PropTypes.string,
	heading: PropTypes.string,
	heroCopy: PropTypes.object,
	midSectionCopy: PropTypes.object,
	tabSectionCopy: PropTypes.object,
	portableTextBlock: PropTypes.array,
	heroImage: PropTypes.object,
	singleColumn: PropTypes.bool,
	waveBelow: PropTypes.bool,
	waveAbove: PropTypes.bool,
	colorlist: PropTypes.object,
	vsmHeroImageModal: PropTypes.object,
}
